var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddMember(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 19,
    viewBox: "0 0 23 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0252 0C5.42946 0 3.3252 2.10426 3.3252 4.7C3.3252 7.29574 5.42946 9.4 8.0252 9.4C10.6209 9.4 12.7252 7.29574 12.7252 4.7C12.7252 2.10426 10.6209 0 8.0252 0ZM8.025 1.7998C9.62663 1.7998 10.925 3.09818 10.925 4.6998C10.925 6.30143 9.62663 7.5998 8.025 7.5998C6.42337 7.5998 5.125 6.30143 5.125 4.6998C5.125 3.09818 6.42337 1.7998 8.025 1.7998ZM16.0452 15.8849C15.9327 13.389 13.8736 11.4 11.35 11.4H4.7L4.48486 11.4048C1.98898 11.5173 0 13.5764 0 16.1V18L0.00701228 18.1129C0.0625482 18.5567 0.441179 18.9 0.9 18.9C1.39706 18.9 1.8 18.4971 1.8 18V16.1L1.80492 15.9296C1.89313 14.4073 3.15558 13.2 4.7 13.2H11.35L11.5204 13.2049C13.0427 13.2931 14.25 14.5556 14.25 16.1V18L14.257 18.1129C14.3125 18.5567 14.6912 18.9 15.15 18.9C15.6471 18.9 16.05 18.4971 16.05 18V16.1L16.0452 15.8849ZM18.9498 4.75C19.4086 4.75 19.7873 5.09334 19.8428 5.53711L19.8498 5.65V7.6001H21.8002C22.2973 7.6001 22.7002 8.00304 22.7002 8.5001C22.7002 8.95892 22.3569 9.33755 21.9131 9.39309L21.8002 9.4001H19.8498V11.35C19.8498 11.8471 19.4469 12.25 18.9498 12.25C18.491 12.25 18.1124 11.9067 18.0568 11.4629L18.0498 11.35V9.4001H16.1002C15.6031 9.4001 15.2002 8.99715 15.2002 8.5001C15.2002 8.04128 15.5435 7.66265 15.9873 7.60711L16.1002 7.6001H18.0498V5.65C18.0498 5.15294 18.4527 4.75 18.9498 4.75Z",
    fill: "#587E85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddMember);
export default __webpack_public_path__ + "static/media/add-member.08bb04d07c42f1224a4db18f0b3da6b5.svg";
export { ForwardRef as ReactComponent };